const io = require("socket.io-client");
window.io = require("socket.io-client");